var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxsGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.223,
    height: 11.921,
    viewBox: "0 0 13.223 11.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs_group",
    transform: "translate(-1.392 -2.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M6.611,8.5A2.834,2.834,0,1,0,3.827,5.665,2.812,2.812,0,0,0,6.611,8.5Zm1.044.708H5.567a4.218,4.218,0,0,0-4.176,4.25v.708H11.831v-.708A4.218,4.218,0,0,0,7.655,9.207Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M11.556,7.826a4.075,4.075,0,0,0,.523-2.437,4.284,4.284,0,0,0-1.951-3.145l-.769,1.18a2.893,2.893,0,0,1,1.335,2.107,2.658,2.658,0,0,1-.139,1.143,2.623,2.623,0,0,1-.608.972l-.83.844,1.126.336a4.242,4.242,0,0,1,2.979,3.924h1.392A5.668,5.668,0,0,0,11.556,7.826Z",
    fill: "#c19444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsGroup);
export default __webpack_public_path__ + "static/media/bxs_group.8307de722601b362d67ae84660732d12.svg";
export { ForwardRef as ReactComponent };